function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.6364 14.0909V12.6364C12.6364 11.0297 11.3339 9.72727 9.72727 9.72727H3.90909C2.30244 9.72727 1 11.0297 1 12.6364V14.0909",
  stroke: "#2D3A45",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.81815 6.81818C8.4248 6.81818 9.72724 5.51574 9.72724 3.90909C9.72724 2.30244 8.4248 1 6.81815 1C5.2115 1 3.90906 2.30244 3.90906 3.90909C3.90906 5.51574 5.2115 6.81818 6.81815 6.81818Z",
  stroke: "#2D3A45",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M17.0001 14.0909V12.6364C16.9991 11.3106 16.1019 10.1532 14.8182 9.82182",
  stroke: "#2D3A45",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.9091 1.09454C13.1963 1.42412 14.0966 2.58399 14.0966 3.91273C14.0966 5.24146 13.1963 6.40133 11.9091 6.73091",
  stroke: "#2D3A45",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.df0c8478.svg";
export { ForwardRef as ReactComponent };